import React, { useEffect } from "react";
import { FILEHISTORYINFO } from "../../App.config";
import * as utilities from "../../utilities/utils";
import moment from "moment";

const SelectedDomainUserModalComponent = (props) => {

    return (
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                        {"Users"}
                    </h5>
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => props.closeRemoveModal()}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body" style={{ height: "500px" }}>
                    {/* <span> */}
                    <div className="row">
                        <div className="col-12 domain-user">
                            <div className="alert alert-warning">
                                {
                                    props.selectedDomainUsers.length + " Users allocated to this domain, If you want to delete, please delete/update users domain."
                                }
                            </div>
                        </div>
                    </div>

                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Full Name</th>
                                <th scope="col">Email</th>
                            </tr>
                        </thead>
                        {Array.isArray(props.selectedDomainUsers) &&
                            props.selectedDomainUsers.length
                            ? props.selectedDomainUsers.map((user, i) => (
                                <tbody>
                                    <tr>
                                        <th scope="row">{i + 1}</th>
                                        <td>{user.firstName + " " + user.lastName}</td>
                                        <td>{user.email}</td>
                                    </tr>
                                </tbody>
                            ))
                            : null}
                    </table>
                </div>
            </div>
        </div>
    );
};
export default SelectedDomainUserModalComponent;
